import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { purple, transition } from './glowUtil'
import { DOT_PREFIX } from './constant'

const focusGlow = `0 0 0 2px ${purple[500]}12, 0 0 4px ${purple[500]}08 !important`

export default genComponentStyleHook(['Input', 'heroTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    // Input 基础
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 12,

      '&:hover': {
        borderColor: `${purple[400]} !important`,
      },
      '&:focus, &-focused': {
        borderColor: `${purple[500]} !important`,
        boxShadow: focusGlow,
      },
    },

    // Input.Search / Input.Password 等包装器
    [`${componentCls}-affix-wrapper${DOT_PREFIX}`]: {
      transition,
      borderRadius: 12,

      '&:hover': {
        borderColor: `${purple[400]} !important`,
      },
      [`&${componentCls}-affix-wrapper-focused`]: {
        borderColor: `${purple[500]} !important`,
        boxShadow: focusGlow,
      },
    },

    // TextArea
    [`${componentCls}${DOT_PREFIX}${componentCls}-textarea`]: {
      '&:hover': {
        borderColor: `${purple[400]} !important`,
      },
      '&:focus': {
        borderColor: `${purple[500]} !important`,
        boxShadow: focusGlow,
      },
    },
  }
})
